import { useCardsRouterContext } from '@apps/card/Card.routes';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import type { ConciergeProduct } from '@apps/card/concierge/conciergeProduct.types';

export const useCustomizePaperlustConcierge = () => {
  const { goToConcierge } = useCardsRouterContext();

  const handleCustomizePaperlustConciergeClick = useEventCallback((product: ConciergeProduct) => {
    goToConcierge(product.identifier);
  });

  return {
    handleCustomizePaperlustConciergeClick,
  };
};
